import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { FeatureNode } from 'libs/ng-components/map/src/lib/models/feature-note';
import {
  DistribuzioneStatistica,
  finestraTemporale,
  messaggioErrore,
  PuntoDettaglioResponse,
  RiskClass
} from 'libs/ng-components/map/src/lib/models/rischio-analitico.model';
import { RischioAnaliticoStateService } from 'libs/ng-components/map/src/lib/services/rischio-analitico-state.service';
import { RischioAnaliticoService } from 'libs/ng-components/map/src/lib/services/rischio-analitico.service';
import { Feature } from 'ol';
import { Geometry } from 'ol/geom';

interface SerieData {
  name: string;
  value: number;
  riskClass: RiskClass | null;
}

/**
 * Form filtri della sezione "Monitoraggio rischio analitico", condiviso tra i sotto-tab
 * Mappa e Riepilogo.
 */
@Component({
  selector: 'ebw-monorepo-rischio-analitico-detail',
  templateUrl: './rischio-analitico-detail.component.html',
  styleUrls: ['./rischio-analitico-detail.component.scss'],
  providers: [DatePipe]
})
export class RischioAnaliticoDetailComponent {
  public features: Feature<Geometry>[] = [];

  public detailData: { name: string; series: SerieData[]; yLabel: string; distribuzione: DistribuzioneStatistica | null }[] = [];

  public selectedNode: FeatureNode = undefined;

  public caricamentoDettaglio = false;
  public erroreDettaglio: string | null = null;

  constructor(private _state: RischioAnaliticoStateService, private _rischioAnaliticoService: RischioAnaliticoService, private _datePipe: DatePipe) {
    this._state.detailFeature$.subscribe((features: Feature<Geometry>[]) => {
      this.selectedNode = undefined;
      this.detailData = [];
      this.features = [...features];
    });
  }

  get hasSelectedAnalytes(): boolean {
    return !!this._state.filtri.codiciParametro?.length;
  }

  public onNodeSelected(event: FeatureNode): void {
    this.selectedNode = event;
    // il dettaglio del punto selezionato prima non deve restare a video mentre si carica (o se fallisce) il nuovo
    this.detailData = [];
    this.erroreDettaglio = null;
    const { filtri } = this._state;
    // senza analiti selezionati non c'e' nessun trend da chiedere: il template mostra l'invito a sceglierne
    if (!filtri.codiciParametro?.length) return;
    this.caricamentoDettaglio = true;
    const finestra = finestraTemporale(filtri.criterio, filtri.annoRiferimento, filtri.dataInizio, filtri.dataFine);
    this._rischioAnaliticoService
      .getDettaglioPunto(
        (<Feature>event.nodeData).getProperties().punto.puntoUuid,
        filtri.codiciParametro.join(','),
        finestra.dataInizio,
        finestra.dataFine
      )
      .subscribe({
        next: (response: PuntoDettaglioResponse) => {
          this.caricamentoDettaglio = false;
          const sortedData = [...response.serieStorica].sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());

          this.detailData = [];
          for (const row of sortedData) {
            const index = this.detailData.findIndex((data) => data.name === row.parameter);

            const punto: SerieData = { name: this._datePipe.transform(row.date, 'dd/MM/yy'), value: row.value, riskClass: row.risk_class };

            if (index === -1) {
              const parametro = response.parametri.find((p) => p.codiceParametro === row.parameter);
              this.detailData.push({
                name: row.parameter,
                series: [punto],
                yLabel: row.um,
                distribuzione: parametro?.distribuzione ?? null
              });
            } else {
              this.detailData[index].series.push(punto);
            }
          }
        },
        error: (error) => {
          console.error('Errore nel caricamento del dettaglio punto', error);
          this.caricamentoDettaglio = false;
          this.erroreDettaglio = messaggioErrore(error, 'Impossibile caricare il dettaglio del punto. Riprova più tardi.');
        }
      });
  }
}
